{
  "version": "2.5.4",
  "build": 345,
  "date": "2026-09-16"
}
